import { connect } from "react-redux";
import ViewLead from "./viewLead";
import { bindActionCreators } from "redux";
import { getDetails } from "services/redux/sales/preSaleListing/action";
import { contractInvoicePreview } from "services/redux/sales/postSales/contractNew/action";

const mapStateToProps = (state) => ({
  viewDetails: state.preSalesListReducer.viewDetails
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDetails,
      contractInvoicePreview,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewLead);
